export const debounce = (func, wait, immediate) => {
  let timeout
  let nbDebounce = 0
  return () => {
    const context = this
    // eslint-disable-next-line no-undef
    const args = arguments
    const later = () => {
      timeout = null
      if (!immediate) {
        func.apply(context, args)
      }
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow || nbDebounce > 10) {
      nbDebounce = 0
      func.apply(context, args)
    } else {
      nbDebounce += 1
    }
  }
}

export const createId = ({ name, hash }) => `___scroll-section___${name || ''}___${hash || ''}`
export const extractHashFromId = ({ id }) => id.split('___scroll-section___')[1].split('___')[1]

export const getAnchoreByName = (object = {}, name) => {
  const key = Object.keys(object).find((key) => object[key].name === name && !object[key].hash)
  return key ? object[key] : null
}
